









import { Component, Vue } from 'vue-property-decorator'
import './index.less'
import portalFooter from './footer.vue'

@Component({
  name: 'LayoutIndex',
  components: {
    portalFooter
  }
})
export default class extends Vue {}
